import { ItemVisitData, ViewItem } from './itemModel'
import { summarizeVisits } from './visitSummary'
import MultiSelect from '../common/FormControls/MultiSelect'
import VisitSelectLabel from './VisitSelectLabel'

export type Props = {
  visitData: ItemVisitData[]
  viewItems: ViewItem[]
  selectedVisitIds: string[]
  onChange: (selectedVisitIds: string[]) => void
}

export const VisitSelector = ({visitData, viewItems, selectedVisitIds, onChange}: Props) => {
  const visitSummaries = summarizeVisits(visitData, viewItems)

  return <MultiSelect 
    options={visitSummaries.map(x => ({value: x.visitId, label: <VisitSelectLabel visit={x} />}))}
    maxTagCount={3}
    placeholder="Select Visits"
    selectedValues={selectedVisitIds}
    onChange={onChange}
    tagRender={visitId => <>{visitSummaries.find(x => x.visitId === visitId)?.date ?? ''}</>}
    style={{width: 300}}
    allSelectedText="All Visits Selected"
    />
}
